module.exports = __webpack_public_path__ + "img/checkbox.5018b68c.png";